<template>
  <v-app class="bg-lightBlue">
    <v-container>
    </v-container>
  </v-app>
</template>

<script>
import getLanguage from '../../../utils/getLanguage';

export default {
  created() {
    const lang = getLanguage(window.location.href);
    if (lang === 'pt-BR') {
      this.$router.push('/psicologo/cadastro-bancario-br/');
    } else {
      this.$router.push('/psicologo/cadastro-bancario-pt/');
    }
  },
};
</script>